<template>
  <v-card>
    <Edit :editDialog="editDialog" :task="selectedTask" @close="editClose" />
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">{{ task.length }} My Task</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="text-xs-right">
        <v-checkbox hide-details label="Hide Complete" v-model="hideCompleteOne"></v-checkbox>
      </div>
    </v-toolbar>
    <v-card-text v-if="isLoading">
      <v-progress-linear
        size="50"
        width="7"
        indeterminate="indeterminate"
        color="pink"
      ></v-progress-linear>
    </v-card-text>
    <div v-else>
      <v-list class="list-800" two-line v-if="task.length !== 0">
        <template v-for="(row, index) in taskList">
          <v-list-tile :key="row.id" avatar>
            <v-list-tile-avatar>
              <v-checkbox
                hide-details
                @change="complateTask(row)"
                class="mt-0"
                :key="row.id"
                v-model="row.isComplete"
              ></v-checkbox>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <span :class="{ linethrough: row.isComplete }">{{
                  row.title
                }}</span></v-list-tile-title
              >
              <v-list-tile-sub-title class="text--primary">
                <span>{{ row.createdAt | moment("from", "now") }}</span>
                <span v-if="row.dueDate">
                  | <span class="red--text"> {{ row.dueDate | moment("from", "now") }}</span>
                </span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ row.description }}</v-list-tile-sub-title>
              <!-- <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title> -->
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon @click="$router.push({ path: `/task/profile/${row.id}` })">
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 < task.length" :key="index"></v-divider>
        </template>
      </v-list>
      <v-card-text v-else>
        <div>No Task!</div>
        <v-card color="black">
          <v-card-text style="color: white;" class="subheading">
            {{ message[Math.floor(Math.random() * message.length)] }}
          </v-card-text>
        </v-card>
        <div class="text-xs-right font-weight-medium">Muhammad Saqib</div>
        <div class="text-xs-right font-weight-medium">CEO</div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
// import dashbaordService from '../service.js'
const Edit = () => import("../components/Edit");
import { mapGetters } from "vuex";
import { TASK } from "../../../../helper/Constant";
import taskService from "../../Tasks/service";
// import "vue-status-indicator/styles.css";

export default {
  data() {
    return {
      message: [
        "A lot of people failed at what you accomplished, simply because they were busy finding problems while you were busy finding solutions. Well done.",
        "Doing anything with perfection is like wearing an impeccable suit – the best way to make a great impression. Well done.",
        "May success follow you, each and every place you go. In the halo of prosperity, may you always glow. May you get everything, that you could ever ask for. Great times lie ahead for you, of that we are very sure. Well done.",
        "Opportunity comes to those who quit Waiting and start Looking. Success comes to those who quit Thinking and start Doing. Congratulations for Looking and Doing. Well done.",
        "One job well done can be redemption for many a mistake of the past. Keep it up.",
        "Less problems, more solutions – keep working like this and nothing will be able to stop you from reaching the top. Good job.",
        'A lot of people in this office are busy Planning, Plotting, Discussing and Strategizing. You are the only one busy Doing. Well done.',
        ' The tipping point between a boy and a man is a job well done. Congratulations.',
        'Your work speaks volumes of the kind of man you are – efficient, organized and result-oriented. Well done.',
        'Skills can be imparted, but the will to persist and persevere is inborn… a talent you have been blessed with. Well done.',
        'Pursuing excellence is not a one time job. It is a way of life. Good job.',
        'You have a habit of outdoing everyone else, but this time you outdid yourself. Well done.',
        'Self-Belief is the fine line which separates the successful from the naysayers. You have lots of it. Well done.',
        'Any job well done is a one-time investment which will reap rewards for the rest of your life in the form of skill, knowledge, expertise and goodwill. Well done, mate.',
        'Doing a good job is not always about impressive innovation. Sometimes it is only about doing something with plain dedication. Well done.',
        'A job well done is the epitaph of mediocrity and the prologue of excellence. Well done.',
        'Not a single effort of yours will go in vain. You will be rewarded for your pain. Your hard work will bring you a lot of gain. Well done.',
        'You have proved that lack of experience in a job doesn’t really matter when there is a strong urge for excellence and perfection. Well done.',
        'Your contribution to the project proves what we already knew – that you are a strong team player and a connoisseur of excellence. Well done.',
        'People like you take the IM out of IMpossible by becoming PRO at tackling PROblems. Well done.',
        'The amount of work and effort you put into your job is way more than your salary. If you keep working like this, that equation might be reversed. Well done.',
        'If our team were a car, you would be the fuel that accelerates it to its limits. Well done.',
        'There is nothing I can SAY which will have a greater impact than what you have DONE. Good job.',
        'You may have listed your college degree but you have forgotten to add your most important skills in your resume – Perseverance. Congratulations for completing the project, well done.',
        'This message is to recognize your contribution in the team’s success. Your commitment has been exemplary and your hard work is an inspiration to everyone around you. Well done.',
        'Even the smallest of jobs well done will take you one step closer towards the success that you have always dreamed about. Keep it up.',
        'Every time you do a good job, you polish yourself one more time. Shine on mate, well done.',
        'The feeling of doing a good job is like burping in satisfaction after having the last spoon of dessert. Congratulations for your burp.',
        'A lot of people wait for opportunities to come and knock on their door. Only few people like you step out to look for them. No wonder, you are a winner. Well done.',
        'Your hard work has proved that this job was destined for you. You have made me realize that I made the right decision by delegating it to you. Well done.',
        'Many others failed because they had a lot of excuses. You succeeded because you didn’t have any. Well done.',
        ' The first step in a long journey of perfection and success starts with a job well done. Congratulations.',
        'When you give something your twenty percent, you finish a chore. When you give it your fifty percent, you finish a task. But when you give it your hundred percent, you do a good job. Well done for your 100%.',
        'Congratulations for realizing that Hard Work is the best key to unlock doors of Opportunity and Success. Well done.',
        'A job that is well done is like a benchmark. It will help you do a better job the next time. Congratulations.',
        'Every good job is the beginning of good things to come. May this one be the start of many other jobs that make your future awesome. Well done.',
        'Some people in our office dress suavely, some talk with panache and some carry themselves nicely to make good impressions. But you are one of the few people who cut the nonsense and just rely on getting jobs done to make the perfect impressions. Well done.',
        'Well Done are the two words that will make your five thousand word research project totally worth it. Good going.',
        'Every time you excel at a task, you are indirectly investing in yourself. Next time, you will strive to do better which will result in better rewards. Well done.',
        'You have done everything possible that an ideal colleague would do… and for that I want to give a congratulatory pat on the back to you. Well done.'
      ],
      selectedTask: {},
      editDialog: false,
      task: [],
      isLoading: true,
      updateInfo: false,
      hideCompleteOne: true
    };
  },
  components: {
    Edit
  },
  sockets: {
    checkTasks() {
      this.getAll();
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    taskList() {
      let listOfTask = [];
      if (this.hideCompleteOne) {
        this.task.map(row => {
          if (!row.isComplete) listOfTask.push(row);
        });
      } else {
        listOfTask = this.task;
      }

      return listOfTask;
    }
  },
  mounted() {
    this.getAll();
    console.log("test", this.message[Math.floor(Math.random() * this.message.length)]);
    this.$events.listen("refresh-task-today", data => this.getAll());
  },
  methods: {
    editClose() {
      this.selectedTask = {};
      this.editDialog = !this.editDialog;
    },
    complateTask(data) {
      return taskService.update(data.id, { isComplete: data.isComplete });
    },
    async reset() {
      await this.getAll();
    },
    editTask(row) {
      this.selectedTask = row;
      this.editDialog = !this.editDialog;
    },
    getAll() {
      return taskService
        .getAllPendingTask({
          // assignedToUser: [this.currentUser.userID].toString()
          // status: [TASK.STATUS.OPEN.ID].toString()
        })
        .then(result => {
          console.log("task", result);
          this.task = result.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.log("error is ..", error);
        });
    }
  }
};
</script>

<style scoped>
.linethrough {
  text-decoration: line-through;
}
.list-800 {
  max-height: 800px;
  overflow: auto;
}
</style>
